import classNames from "classnames";
import styles from "./Symbol.module.scss";
import symbolColors from "./symbol-colors";

export type SymbolSize = "small" | "medium" | "large";
export type SymbolColor = (typeof symbolColors)[number];

interface SymbolProps {
  name: string;
  size?: SymbolSize;
  color?: SymbolColor;
  count?: number;
  className?: string;
}

function Symbol({
  size = "small",
  color = "gray",
  name,
  count,
  className,
}: SymbolProps) {
  return (
    <span
      className={classNames(
        styles.symbol,
        styles[`symbol-${size}`],
        styles[`symbol-${color}`],
        className,
      )}
    >
      {name}
      {typeof count === "number" && (
        <span className={styles.symbolCount}>{count}</span>
      )}
    </span>
  );
}

export default Symbol;
